import { c as _c } from "react/compiler-runtime";
import { PERMISSIONS } from '@libs/core';
import { checkUserToolAccess } from '../utils/checkUserToolAccess';
import { useUserData } from './useUserData';
export interface PermissionState {
  isLoading: boolean;
  canAccessCategoryJobs: boolean;
  canAccessPromoJobs: boolean;
  canAccessBulkPromo: boolean;
  canAccessShopCategory: boolean;
}
export const usePermissions = () => {
  const $ = _c(14);
  const {
    groups,
    isLoading
  } = useUserData();
  let t0;
  if ($[0] !== groups) {
    t0 = checkUserToolAccess(groups, PERMISSIONS.CATEGORY_JOBS);
    $[0] = groups;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== groups) {
    t1 = checkUserToolAccess(groups, PERMISSIONS.PROMO_JOBS);
    $[2] = groups;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== groups) {
    t2 = checkUserToolAccess(groups, PERMISSIONS.BULK_PROMO);
    $[4] = groups;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== groups) {
    t3 = checkUserToolAccess(groups, PERMISSIONS.ADMIN);
    $[6] = groups;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isLoading || $[9] !== t0 || $[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = {
      isLoading,
      canAccessCategoryJobs: t0,
      canAccessPromoJobs: t1,
      canAccessBulkPromo: t2,
      canAccessShopCategory: t3
    };
    $[8] = isLoading;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};